import React from 'react';
import { AppConfigContextInterface } from '../../types/AppConfigContextTypes';

// Create a context with no initial values.
export const AppConfigContext = React.createContext<AppConfigContextInterface | null>(
  null,
);

export default AppConfigContext;
